export interface EndCallScreenProps {
  title?: string;
  message?: string;
}

export const EndCallScreen = ({
  title = 'Call Ended',
  message = 'Thanks for your time.',
}: EndCallScreenProps) => {
  return (
    <div className='flex h-full w-full items-center justify-center'>
      <div className='flex w-full max-w-md flex-col items-center gap-4 rounded-lg border border-border bg-background p-6 text-center shadow-sm'>
        <h2 className='text-xl font-semibold'>{title}</h2>
        <p className='text-sm text-muted-foreground'>{message}</p>
      </div>
    </div>
  );
};

export type { EndCallScreenProps as Props };
